import { ReactNode, Suspense } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Button, LoaderOverlay } from 'components';
import styles from './SuspenseBoundary.module.scss';

type SuspenseBoundaryProps = {
    children: ReactNode,
    loadingComponent?: ReactNode,
    errorMessage: string,
    onReset: () => void
};

export default function SuspenseBoundary(props: SuspenseBoundaryProps) {
    const { children, loadingComponent, errorMessage, onReset } = props;

    const ErrorComponent = ({ error, resetErrorBoundary }: FallbackProps) => (
        <div className={styles.container}>
            <h4>{errorMessage ?? error?.message}</h4>
            <Button fillMode="outline" themeColor="primary" onClick={resetErrorBoundary}>
                Try Again
            </Button>
        </div>
    );

    return (
        <ErrorBoundary FallbackComponent={ErrorComponent} onReset={onReset}>
            <Suspense fallback={loadingComponent ?? <LoaderOverlay isLoading />}>
                {children}
            </Suspense>
        </ErrorBoundary>
    );
}